import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Flex } from 'reflexbox';
import {
  ButtonCircle,
  Text,
} from 'rebass';

import config from 'frontend/config';
import If from './If';
import Icon from './Icon';

const ErrorText = ({ children, iconSize, fontSize, noIcon, ...props }) => (
  <Flex align="center" {...props}>
    <If
      condition={!noIcon}
      then={() => (
        <ButtonCircle
          mr={1}
          backgroundColor={config.colors.error}
          size={iconSize}
          style={{
            minWidth: iconSize,
            minHeight: iconSize,
            lineHeight: iconSize,
            paddingLeft: 1,
          }}
        >
          <Icon name="close" size={_.round(iconSize * 0.75)} fill={config.colors.black} style={{ margin: 'auto' }} />
        </ButtonCircle>
      )}
    />
    <Text bold color={config.colors.error} style={{ fontSize }}>
      {children}
    </Text>
  </Flex>
);

ErrorText.propTypes = {
  children: PropTypes.node.isRequired,
  iconSize: PropTypes.number,
  fontSize: PropTypes.number,
  noIcon: PropTypes.bool,
};

ErrorText.defaultProps = {
  iconSize: 23,
  fontSize: 17,
  noIcon: false,
};

export default ErrorText;
